var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addProduct_main"},[_c('pad-head-panel3',{attrs:{"title":'新增商品',"isShowHome":true}}),_vm._v(" "),_c('div',{staticClass:"am_con"},[_c('product-detail',{attrs:{"isEdit":false}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/template-compiler?{"id":"data-v-43f93e62","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/padViews/product/addProduct.vue
// module id = null
// module chunks = 